import axiosInstance from '@/axios/axios';

import type { ApiConfig } from './Swagger';
import { HttpClient } from './Swagger';

/**
 * Swagger HttpClient 확장.
 */
export class AclosetHttpClient extends HttpClient<void> {
  constructor(configs: ApiConfig<void> = {}) {
    super(configs);
    this.instance = axiosInstance;
  }
}
